import React, { Component } from 'react';

import resolveJSONPath from '../utils/resolve-json-path';

import InputAdornment from '@material-ui/core/InputAdornment';
import CircularProgress from '@material-ui/core/CircularProgress';

import ErrorIcon from '@material-ui/icons/Error';

export const defaultDataProp = 'value';
export const defaultErrorsProp = 'error';

/**
 * Class to group common actions in composable forms handling
 *
 * Most of time, current value is received by the element on ${dataProp} prop, errors on
 * ${errorsProp}.
 */
export default class PartialForm extends Component {
  dataProp = defaultDataProp;
  errorsProp = defaultErrorsProp;

  state = {
    [this.dataProp]: {},
    [this.errorsProp]: {}
  }

  resolveStatePath(path) {
    return resolveJSONPath(path, this.state);
  }

  resolvePropPath(path) {
    return resolveJSONPath(path, this.props);
  }

  getFormValue(path) {
    return path ? this.resolvePropPath(`${this.dataProp}.${path}`) : this.props[this.dataProp];
  }

  hasInput(name) {
    return !!this.getFormValue(name) && !!String(this.getFormValue(name)).length;
  }

  inputHasError(name) {
    return this.hasInput(name) ? !!this.props[this.errorsProp][name] : false;
  }

  getFormError(name) {
    return name ? this.props[this.errorsProp][name] : this.props[this.errorsProp];
  }

  extractFromEvent({ target: { value } }) { return value; }

  setLoading(loading = true, additionalState) {
    return new Promise(res => this.setState({ ...additionalState, loading }, res));
  }

  startLoading(additionalState) {
    return this.setLoading(true, additionalState);
  }

  stopLoading(additionalState) {
    return this.setLoading(false, additionalState);
  }

  isLoading() {
    return this.props.loading || this.state.loading;
  }

  getAdornment(name) {
    if (this.isLoading()) return <InputAdornment position="end">
      <CircularProgress size={20} />
    </InputAdornment>;

    if (! this.hasInput(name)) return null;

    return this.inputHasError(name)
      && <InputAdornment position="end"><ErrorIcon style={{color: 'red'}}/></InputAdornment>;
  }

  defaultHandle(name, opts) {
    return {
      handle: name,
      readOnly: this.isLoading(),
      InputLabelProps: {
        shrink: this.hasInput(name)
      },
      InputProps: {
        endAdornment: this.getAdornment(name)
      },
      ...opts
    };
  }
}
